const knownList = [
    { id:"0",cname:"否"},
    { id:"1",cname:"是"},
];

export {
    knownList
}
